import { authToken, researchRouteAllowed, normalizeResearchPermissions } from '@/modules/cohort/researchPermissions.js'
import {createRouter, createWebHistory} from 'vue-router'
import Login from './components/Login.vue'
import Dashboard from '@/components/Dashboard.vue'
import Register from "@/components/Register.vue"
import RegisterPhoneCode from "@/components/RegisterPhoneCode.vue"
import LoginPhoneCode from "@/components/LoginPhoneCode.vue"
import RetrievePassword from "@/components/RetrievePassword.vue"
import OrgDashboard from "@/components/OrgDashboard.vue"
import OrgDashboardPillow from "@/components/OrgDashboardPillow.vue"
import OrgReportDetail from "@/components/OrgReportDetail.vue"
import ReportList from "@/components/ReportList.vue"
import MainLayout from "@/components/MainLayout.vue"
import OrgPrintReport from "@/components/OrgPrintReport.vue"
import UserManagementEntry from "@/components/UserManagementEntry.vue"
import SleepAnalysis from './components/SleepAnalysis.vue'
import SleepTrendAnalysis from './components/SleepTrendAnalysis.vue'
import { cohortRoute, cohortSelectorRoute, cohortPrintRoute } from '@/modules/cohort/routes.js'
import { store } from '@/plugins/store.js'
// const routes = [
//     {path: '/', component: Login},
//     {path: '/dashboard', component: Dashboard},
//     {path: '/register', component: Register},
//     {path: '/register2', component: RegisterPhoneCode},
//     {path: '/login', component: LoginPhoneCode},
//     {path: '/retrieve', component: RetrievePassword},
//     {path: '/org-dashboard', component: OrgDashboard},
//     {path: '/reports',
//         name: 'ReportList',
//         component: ReportList,
//         meta: {
//             requiresAuth: true,
//             title: '报告列表'
//           }
//     },
    
//     {
//         path: '/bluetooth-config',
//         name: 'bluetooth-config',
//         component: () => import('@/components/BluetoothConfig.vue')
//       },
//     {
//         path: '/report',
//         name: 'report-detail', // 添加路由名称
//         component: OrgReportDetail,
//         props: (route) => {
//             // 添加错误处理和默认值
//             try {
//                 return {
//                     device: route.query.device || '',
//                     date: route.query.date || '',
//                     selections: route.query.selections ? JSON.parse(route.query.selections) : {},
//                     stage: 1
//                 }
//             } catch (error) {
//                 console.error('Error parsing route props:', error)
//                 return {
//                     device: '',
//                     date: '',
//                     selections: {},
//                     stage: 1
//                 }
//             }
//         }
//     },
// ];
const routes = [
  { path: '/access-denied', component: () => import('@/components/ResearchAccessDenied.vue') },
  {
    path: '/external/raw',
    name: 'ExternalRawData',
    component: () => import('@/components/ExternalRawData.vue'),
    meta: { requiresAuth: false, title: '原始数据' }
  },
  {
    path: '/external/raw/:deviceId/:date',
    name: 'ExternalRawDataPath',
    component: () => import('@/components/ExternalRawData.vue'),
    props: true,
    meta: { requiresAuth: false, title: '原始数据' }
  },
  cohortSelectorRoute,
  cohortPrintRoute,
  cohortRoute,
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/register2',
    name: 'RegisterPhoneCode',
    component: RegisterPhoneCode
  },
  {
    path: '/login-phone',
    name: 'LoginPhoneCode',
    component: LoginPhoneCode
  },
  {
    path: '/retrieve',
    name: 'RetrievePassword',
    component: RetrievePassword
  },
  {
    path: '/sleep-analysis/:deviceId/:date',
    name: 'SleepAnalysis',
    component: SleepAnalysis,
    props: true
  },
  {
    path: '/sleep-trend/:deviceId/:date',
    name: 'SleepTrendAnalysis',
    component: SleepTrendAnalysis,
    props: true
  },
  {
    path: '/questionnaire/:type/:deviceId/:date',
    name: 'questionnaire',
    component: () => import('@/components/QuestionnaireView.vue'),
    props: true
  },
  {
    path: '/field-dictionary',
    name: 'FieldDictionary',
    component: () => import('@/components/FieldDictionary.vue'),
    meta: { requiresAuth: false, title: '数据字段字典' }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',  // 空路径会匹配 '/'
        redirect: '/devices'  // 登录后重定向到设备页
      },
      {
        path: 'devices',
        name: 'Devices',
        component: () => {
          // 从 localStorage 读取 org，决定使用哪个组件
          const userOrg = localStorage.getItem('userOrg')
          console.log('路由定义 - 从 localStorage 读取 userOrg:', userOrg)
          
          if (userOrg === '干预枕') {
            console.log('路由定义 - 使用 OrgDashboardPillow 组件')
            return import('@/components/OrgDashboardPillow.vue')
          }
          
          console.log('路由定义 - 使用默认 OrgDashboard 组件')
          return import('@/components/OrgDashboard.vue')
        }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: () => {
          const userOrg = localStorage.getItem('userOrg');
          console.log('路由定义 - 报告管理页面，从 localStorage 读取 userOrg:', userOrg);
          if (userOrg === '干预枕') {
            console.log('路由定义 - 使用 ReportListPillow 组件');
            return import('@/components/ReportListPillow.vue');
          } else {
            console.log('路由定义 - 使用默认 ReportList 组件');
            return import('@/components/ReportList.vue');
          }
        }
      },
      {
        path: 'users',
        name: 'Users',
        component: UserManagementEntry
      },


      {
        path: 'report',
        name: 'report-detail',
        component: OrgReportDetail,
        props: (route) => {
          try {
            return {
              device: route.query.device || '',
              date: route.query.date || '',
              selections: route.query.selections ? JSON.parse(route.query.selections) : {},
              stage: 1
            }
          } catch (error) {
            console.error('Error parsing route props:', error)
            return {
              device: '',
              date: '',
              selections: {},
              stage: 1
            }
          }
        }
      },
      {
        path: 'user-report/:openid',
        name: 'UserReportPillow',
        component: () => import('@/components/OrgUserReportDetailPillow.vue'),
        props: true
      }
    ]
  },
      {
        path: '/report',
        name: 'report-detail', // 添加路由名称
        component: OrgPrintReport,
        props: (route) => {
            // 添加错误处理和默认值
            try {
                return {
                    device: route.query.device || '',
                    date: route.query.date || '',
                    selections: route.query.selections ? JSON.parse(route.query.selections) : {},
                    stage: 1
                }
            } catch (error) {
                console.error('Error parsing route props:', error)
                return {
                    device: '',
                    date: '',
                    selections: {},
                    stage: 1
                }
            }
        }
    },
]
const router = createRouter({
    history: createWebHistory(),
    routes
})

const originalEntryPaths = new Set(['/', '/devices', '/reports', '/users'])

const displayModeEntry = user => user?.sleepreport_display_mode === 'cohort' ? '/cohorts' : '/devices'

async function ensureCurrentUser() {
  if (store.state.user && typeof store.state.user === 'object' && store.state.user.user && store.state.userToken === authToken()) {
    return store.state.user
  }
  return await store.dispatch('fetchUser')
}

// 添加全局导航守卫进行错误处理
router.beforeEach(async (to, from, next) => {
  const urlToken = to.query.token;
  const isExternalRaw = to.path.startsWith('/external/raw')
  
  // 添加一个标记，避免重复处理token
  if (urlToken && !to.query.processed) {
    try {
      // 先清除旧token
      // localStorage.clear();
      
      // 设置新token
      store.commit('setUser', null);
      localStorage.setItem('authToken_org', urlToken);

      localStorage.setItem('authToken1_org', urlToken);
      
      // 验证token是否确实被设置
      const savedToken = localStorage.getItem('authToken_org');
      
      if (!savedToken) {
        throw new Error('Token 保存失败');
      }

      // 重定向时添加processed标记，避免重复处理
      // 外部原始数据页面：不跳转到 /devices，保留当前 URL
      if (isExternalRaw) {
        next({
          path: to.path,
          query: { ...to.query, processed: true }
        })
      } else {
        const user = await ensureCurrentUser()
        next({
          path: displayModeEntry(user),
          query: { processed: true }
        });
      }
      return;
    } catch (error) {
      console.error('设置 token 时出错:', error);
      next('/login');
      return;
    }
  }

  const isAuthenticated = authToken()
  
  const isAuthenticated1 = localStorage.getItem('authToken1_org')

  if(!isAuthenticated && isAuthenticated1){  
    localStorage.setItem('authToken_org', isAuthenticated1);

  }

  // 如果是根路径且未登录，重定向到登录页≥
  if (to.path === '/' && !isAuthenticated) {
    next('/login')
    return
  }
  
  // Apply to public/legacy aliases too: direct URL navigation cannot mount export/admin views.
  if (authToken()) {
    const user = await ensureCurrentUser()
    if (!user) { next(false); return }
    if (!researchRouteAllowed(user, to.path)) {
      next(normalizeResearchPermissions(user).edit ? '/cohort/subjects' : '/access-denied')
      return
    }
  }

  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next('/login')
      return
    }
    
    const currentUser = await ensureCurrentUser()
    if (currentUser?.user !== 'admin' && currentUser?.sleepreport_display_mode === 'cohort' && originalEntryPaths.has(to.path)) {
      next('/cohorts')
      return
    }

    // 如果是设备管理页面，根据用户 org 动态切换组件
    if (to.name === 'Devices') {
      // 从 localStorage 读取 org（更可靠，因为 store 可能还没初始化）
      let userOrg = localStorage.getItem('userOrg')
      console.log('路由守卫 - 从 localStorage 读取 userOrg:', userOrg)
      
      // 如果没有 userOrg，尝试从 store 读取
      if (!userOrg) {
        try {
          const user = store.state.user
          if (user && user.org) {
            userOrg = user.org
            // 保存到 localStorage 以便后续使用
            localStorage.setItem('userOrg', userOrg)
            console.log('路由守卫 - 从 store 读取并保存 userOrg:', userOrg)
          }
        } catch (e) {
          console.log('路由守卫 - store 未初始化，无法读取 userOrg')
        }
      }
      
      // 如果还是没有 userOrg，尝试获取用户信息（同步等待）
      if (!userOrg && isAuthenticated) {
        try {
          console.log('路由守卫 - userOrg为空，尝试获取用户信息')
          // 同步等待获取用户信息
          await store.dispatch('fetchUser')
          const newUserOrg = localStorage.getItem('userOrg')
          console.log('路由守卫 - 获取到新的 userOrg:', newUserOrg)
          if (newUserOrg === '干预枕') {
            console.log('路由守卫 - 获取到 userOrg 为干预枕，重新导航')
            // 重新导航以确保使用正确的组件
            next({ ...to, replace: true })
            return
          }
          userOrg = newUserOrg // 更新 userOrg
        } catch (e) {
          console.error('路由守卫 - 无法获取用户信息:', e)
        }
      }
      
      // 添加调试日志
      try {
        console.log('路由守卫 - 最终 userOrg:', userOrg, '用户角色:', store?.state?.user?.role || '未知')
      } catch (e) {
        console.log('路由守卫 - 最终 userOrg:', userOrg, '用户角色: 未知（store未初始化）')
      }
      
      // 根据 userOrg 动态设置组件
      if (userOrg === '干预枕') {
        console.log('路由守卫 - 使用 OrgDashboardPillow 组件')
        const matched = to.matched.find(r => r.name === 'Devices')
        if (matched) {
          matched.components.default = () => import('@/components/OrgDashboardPillow.vue')
        }
      } else {
        console.log('路由守卫 - 使用默认 OrgDashboard 组件, userOrg:', userOrg)
      }
    }
  }
  
  // 如果已登录且访问登录页，重定向到首页
  if (isAuthenticated && to.path === '/login') {
    const currentUser = await ensureCurrentUser()
    next(displayModeEntry(currentUser))
    return
  }

  // 报告详情的验证逻辑
  if (to.name === 'report-detail') {
    const { device, date, selections } = to.query
    if (!device || !date || !selections) {
      console.error('Missing required query parameters')
      next('/devices')
      return
    }
  }
  
  next()
})

// 添加错误处理
router.onError((error) => {
    console.error('Router error:', error)
})

export default router
